var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#light-bulb_svg__clip0_8073_133378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.69 13.48c-.06 3.21-1.16 6.13-2.93 8.38-.95 1.2-1.74 2.52-2.21 4.01-.11.35-.22.73-.32 1.13h-6.8c-.12-1.3-.64-2.13-2.74-3.4C4.36 17.29 7.97 6.81 8.09 6.23 10.16 2.54 13.82.09 18 .09h.03c5.47 1.34 9.31 4.16 11.66 13.39z",
    fill: "#EFB003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.43 27h-5.68c-.08-.36-.18-.7-.28-1.03-.47-1.53-1.29-2.9-2.27-4.14-1.8-2.31-2.9-5.32-2.9-8.64 0-2.55.65-4.94 1.79-6.96-.12.58-3.73 11.06 6.6 17.37 2.1 1.27 2.62 2.1 2.74 3.4z",
    fill: "#7C3B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.56 12.58h-6.39c-.51 0-.92-.41-.92-.92v-1.2c0-.51.41-.92.92-.92h6.39c.51 0 .92.41.92.92v1.2c0 .51-.41.92-.92.92zm.92 5.09v-1.2c0-.51-.41-.92-.92-.92h-12.3c-.51 0-.92.41-.92.92v1.2c0 .51.41.92.92.92h12.3c.51 0 .92-.41.92-.92z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.36 10.97V8.78c0-.32.32-.52.58-.36l1.78 1.1 1.78 1.1c.26.16.26.56 0 .72l-1.78 1.1-1.78 1.1c-.26.16-.58-.04-.58-.36v-2.21z",
    fill: "#FFEF27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7 13.19c0 .1 0 .19-.01.29C27.34 4.25 23.51 1.43 18.03.09c6.45.02 11.67 5.88 11.67 13.1z",
    fill: "#FCD222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38 13.49c0-.51-.43-.91-.99-.91H.99c-.53 0-.99.41-.99.91s.43.91.99.91H4.4c.53 0 .99-.41.99-.91h-.01zM3.82 17.72l-2.46 2.46c-.38.38-.41.99-.05 1.34.18.18.38.25.61.25.25 0 .51-.1.71-.3l2.46-2.46c.38-.38.41-.99.05-1.34-.35-.35-.94-.33-1.34.05h.03-.01zM3.82 9.24c.2.2.46.3.71.3.23 0 .46-.08.61-.25.35-.35.33-.94-.05-1.34L2.63 5.49c-.38-.38-.99-.41-1.34-.05-.35.35-.33.94.05 1.34L3.8 9.24h.03-.01zM30.62 13.49c0-.51.43-.91.99-.91h3.41c.53 0 .99.41.99.91 0 .51-.43.91-.99.91h-3.41c-.53 0-.99-.41-.99-.91zM32.18 17.72l2.46 2.46c.38.38.41.99.05 1.34-.18.18-.38.25-.61.25-.25 0-.51-.1-.71-.3l-2.46-2.46c-.38-.38-.41-.99-.05-1.34.35-.35.94-.33 1.34.05h-.03.01zM32.18 9.24c-.2.2-.46.3-.71.3-.23 0-.46-.08-.61-.25-.35-.35-.33-.94.05-1.34l2.46-2.46c.38-.38.99-.41 1.34-.05.35.35.33.94-.05 1.34L32.2 9.24h-.03.01z",
    fill: "#EFB003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 28.05v2.33c0 .23-.02.47-.06.7-.3 1.76-1.67 3.09-3.34 3.09h-7.61c-1.67 0-3.05-1.33-3.34-3.09-.05-.23-.06-.47-.06-.7v-2.33c0-.58.42-1.05.95-1.05h12.51c.51 0 .94.47.94 1.05h.01z",
    fill: "#BADEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 29.19v-1.01h-7.68c.02-.7.06-1.18.06-1.18h-5.83c-.53 0-.95.47-.95 1.05v2.33c0 .23.01.47.06.7.29 1.76 1.67 3.09 3.34 3.09h5.08s-.79-.01-1.43-.88c-.22-.31-.32-1.19-.35-2.21 0-.093 0-.093 0 0h7.65c.04-.23.06-.47.06-.7v-.29h-7.73c0-.31 0-.61.01-.9 0-.3.01-.3 0 0h7.71z",
    fill: "#80B8BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.05 34.17h-6.11c.04.16.09.31.16.45.36.82 1.11 1.38 1.97 1.38h1.84c.61 0 1.17-.28 1.58-.75.15-.18.29-.4.4-.63.06-.14.11-.29.16-.45zM17.53 28.18h-6.72v1h6.69l.03-1zM17.48 30.09H10.8v.29c0 .23.01.47.06.7h6.63c-.01-.32-.01-.66-.01-.99z",
    fill: "#6D91AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "light-bulb_svg__clip0_8073_133378"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
}

export default SvgLightBulb;